document.addEventListener('DOMContentLoaded', function() {
    const variantRadios = document.querySelectorAll('.quantity-custom input[type="radio"]');

    variantRadios.forEach(radio => {
        const label = radio.nextElementSibling;

        const priceElement = label.querySelector('.quantity-element__price');
        const compareAtPriceElement = label.querySelector('.quantity-element__compare_at_price');

        const variantPrice = priceElement ? parseFloat(priceElement.textContent.replace('€', '').trim().replace(',', '.')) : 0;
        const compareAtPrice = compareAtPriceElement && compareAtPriceElement.textContent.trim() !== '' 
            ? parseFloat(compareAtPriceElement.textContent.replace('€', '').trim().replace(',', '.')) 
            : null;

        const discountElement = label.querySelector('.quantity-element__discount');

        if (discountElement) {
            if (variantPrice === 0 || !compareAtPrice || compareAtPrice <= variantPrice) {
                discountElement.innerHTML = '';
            } else {
                const discount = ((compareAtPrice - variantPrice) / compareAtPrice) * 100;
                discountElement.innerHTML = discount.toFixed(0) + "%";
            }
        }
    });
});
